import { slugsPart1 } from './slugs/slugs_1';
import { slugsPart2 } from './slugs/slugs_2';
import { slugsPart3 } from './slugs/slugs_3';
import { slugsPart4 } from './slugs/slugs_4';
import { slugsPart5 } from './slugs/slugs_5';
import { slugsPart6 } from './slugs/slugs_6';

export const simpleIconsMapping = {
    ...slugsPart1,
    ...slugsPart2,
    ...slugsPart3,
    ...slugsPart4,
    ...slugsPart5,
    ...slugsPart6,
};
